import { useState } from "react";
import MapView from "../../../componnents/MapView";

const Quartier = ({ location = null, position = null }) => {
  const [Layer, setLayer] = useState(true);

  return (
    <section id="quartier" className="mt-70">
      <p className="semibold fs16 pink mb-10">Quartier</p>
      <div className="bg-white radius5 p100 position-relative">
        <div
          className={Layer ? "whiteLayer" : "whiteLayerhidden"}
          onClick={() => setLayer(false)}
        >
          <img src="./icons/mapActivate.svg" />
          <p className="fs20 bold darkGrey">Cliquer pour activer</p>
        </div>
        <div className="quartierMapContainer">
          <MapView locations={location} position={position} />
        </div>
      </div>
    </section>
  );
};

export default Quartier;
